import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Button, Typography } from "@mui/material";
import {
  authProviderConfigurationError,
  isAuthConfigured,
  loginRequest,
} from "authConfig";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loading from "shared-components/Loading";
import styled from "styled-components";
import AuthService from "../../services/AuthService";

const LoginContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgb(0, 0, 0, 0.7);
`;
const Logo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 100px;
`;
interface LogoTextProps {
  subtext?: boolean;
}
const LogoText = styled.div`
  font-family: "Roboto", sans-serif;
  font-size: ${(props: LogoTextProps) => (props.subtext ? "3rem" : "6rem")};
  color: white;
  font-weight: 300;
  line-height: 1;
`;
const RedSpan = styled.span`
  color: ${({ theme }) => theme.palette.primary.main};
`;
const BlueSpan = styled.span`
  color: #3277b1;
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const AuthProviderError = styled(Typography)`
  margin-top: 16px !important;
`;

export const LoginWithMicrosoft = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const history = useHistory();

  useEffect(() => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      AuthService.authCheck()
        .then((response) => {
          if (response.data.me?.userId) {
            const prevLocation = sessionStorage.getItem("prevLocation");
            sessionStorage.removeItem("prevLocation");
            const safePath =
              prevLocation &&
              prevLocation.startsWith("/") &&
              !prevLocation.startsWith("//")
                ? prevLocation
                : "/";
            history.push(safePath);
          }
        })
        .catch(() => {
          // Auth check failed — user will remain on login page
        });
    }
  }, [history, isAuthenticated, inProgress]);

  const handleLogin = () => {
    if (!isAuthConfigured) return;
    void instance.loginRedirect(loginRequest);
  };

  if (isAuthenticated) {
    return <Loading name="rotating-plane" color="red" />;
  }

  return (
    <LoginContainer>
      <Logo>
        <LogoText>
          <BlueSpan>JAX</BlueSpan> | NY<RedSpan>SC</RedSpan>F
        </LogoText>
      </Logo>
      <ButtonContainer>
        <Button
          variant="contained"
          onClick={handleLogin}
          disabled={!isAuthConfigured}
        >
          Sign in
        </Button>
        {!isAuthConfigured && authProviderConfigurationError && (
          <AuthProviderError color="error" role="alert">
            {authProviderConfigurationError}
          </AuthProviderError>
        )}
      </ButtonContainer>
    </LoginContainer>
  );
};
